import { render, staticRenderFns } from "./numbers-list-page.vue?vue&type=template&id=37c2b245&"
import script from "./numbers-list-page.vue?vue&type=script&lang=js&"
export * from "./numbers-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports